import { ReservationStatus } from "@stepapp/core/apiTypes";

import type store from ".";
import type { reducer } from ".";

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof reducer>;

export type EditReservationQuestionType = "date" | "questions" | "services" | "customerNote";

export const ReservationCompletedStatuses = [
  ReservationStatus.Accepted,
  ReservationStatus.AwaitingPayment,
  ReservationStatus.Completed,
  ReservationStatus.PaymentReceived,
  ReservationStatus.Refunded,
  ReservationStatus.Cancelled,
];

export const CanLeaveReviewStatuses = [
  ReservationStatus.Accepted,
  ReservationStatus.AwaitingPayment,
  ReservationStatus.Completed,
  ReservationStatus.PaymentReceived,
  ReservationStatus.Refunded,
  ReservationStatus.CustomerReview,
];

export const ReservationActiveStatuses = [
  ReservationStatus.Pending,
  ReservationStatus.Assigned,
  ReservationStatus.WorkStarted,
];

export const OngoingReservationStatuses = [
  ...ReservationActiveStatuses,
  ReservationStatus.Accepted,
  ReservationStatus.CustomerReview,
  ReservationStatus.AwaitingPayment,
  ReservationStatus.PaymentFailed,
];
